var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vuestic-feed" },
    [
      _vm.posts.length == 0
        ? _c("div", { staticClass: "empty" }, [_vm._v("Your feed is empty.")])
        : _vm._e(),
      _vm._l(_vm.posts, function (post, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "post",
            class: { last: _vm.posts.indexOf(post) === _vm.posts.length - 1 },
          },
          [
            _c("div", { staticClass: "photo-container" }, [
              _c("div", {
                staticClass: "photo",
                style: `background: url(${post.photoURL})`,
              }),
            ]),
            _c("div", { staticClass: "underscored" }, [
              _c("span", { staticClass: "text" }, [
                _c("span", { staticClass: "name" }, [
                  _vm._v(_vm._s(post.name)),
                ]),
                _vm._v(" " + _vm._s(post.text) + "."),
              ]),
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-micro btn-primary btn-with-icon close-btn rounded-icon",
                  on: {
                    click: function ($event) {
                      return _vm.removePost(post)
                    },
                  },
                },
                [_c("i", { staticClass: "ion-md-close ion" })]
              ),
            ]),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }